<template>
  <div class="login-middle-page"></div>
</template>

<script>
import requestApi from '@/service';

export default {
  beforeRouteEnter(to) {
    if (to.query.token) {
      window.$store.commit('setToken', to.query.token);
      requestApi('/v3/api/v1/user/').then(res => {
        if (res && res.user) {
          window.$store.commit('setUser', res.user);
          // 若当前用户未绑定手机 强制跳转绑定
          if (!res.user.mobile) {
            window.$router.replace({
              name: 'UserCenterOrder',
              params: {
                bindMobile: true,
              },
            });
          } else {
            const path = localStorage.loginPrevPage ? JSON.parse(localStorage.loginPrevPage) : '/home';
            window.$router.replace(path);
            localStorage.removeItem('loginPrevPage');
          }
        }
      });
    }
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
